import {
  Box,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Text,
} from '@chakra-ui/react';

const Preview = ({ message, bold, quotes }) => {
  const label = 'Email';
  let t = bold ? `<b>${label}</b>` : label;
  if (quotes) {
    t = `${quotes}${t}${quotes}`;
  }
  const text = message.replaceAll('{#label}', t);

  return (
    <Flex direction="column" mt="4">
      <Text color="gray.600">Preview</Text>
      <Box bg="blackAlpha.10" p="3" boxShadow="md" my="2" maxW="80%">
        <FormControl isInvalid isRequired>
          <FormLabel>{label}</FormLabel>
          <Input type="text" name="email" />
          {/* eslint-disable-next-line react/no-danger */}
          <FormErrorMessage><div dangerouslySetInnerHTML={{ __html: text }} /></FormErrorMessage>
        </FormControl>
      </Box>
    </Flex>
  );
};

export default Preview;
